import type { PropsWithChildren } from "react";

/**
 * Reusable heroic backdrop: red/blue gradient + faint shield glow + stars.
 * Pure CSS — no external assets.
 */
export function Background({ children }: PropsWithChildren) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-cap-deep text-white">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(200,16,46,0.25),transparent_55%),radial-gradient(circle_at_80%_75%,rgba(10,49,97,0.4),transparent_55%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,#06122b_0%,#0a1834_60%,#0c1e3f_100%)] opacity-90" />
        <StarField />
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  );
}

function StarField() {
  // Deterministic-ish star positions via prime offsets — keeps SSR/SR stable.
  const stars = Array.from({ length: 60 }).map((_, i) => {
    const left = (i * 73.31) % 100;
    const top = (i * 37.7) % 100;
    const size = i % 11 === 0 ? 2.5 : 1;
    const delay = (i % 7) * 0.4;
    return (
      <span
        key={i}
        className="absolute rounded-full bg-white/70 animate-pulse-slow"
        style={{
          left: `${left}%`,
          top: `${top}%`,
          width: size,
          height: size,
          animationDelay: `${delay}s`,
          opacity: 0.6,
        }}
      />
    );
  });
  return <div className="absolute inset-0">{stars}</div>;
}
